import { useTranslation } from 'react-i18next'

type Props = {
  page: number
  pageSize: number
  total: number
  onChange: (page: number) => void
}

export default function ScopePager({ page, pageSize, total, onChange }: Props) {
  const { t } = useTranslation()
  if (total <= pageSize) return null
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  return (
    <div className="flex items-center justify-end gap-3 pt-3 text-[13px] text-black/60">
      <button
        type="button"
        className="disabled:opacity-40"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        {t('scope.paginationPrev')}
      </button>
      <span>{t('scope.paginationPage', { page, total: totalPages })}</span>
      <button
        type="button"
        className="disabled:opacity-40"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      >
        {t('scope.paginationNext')}
      </button>
    </div>
  )
}
